module.exports = "<app-inicio></app-inicio>\n\n    \n"